import React from 'react';
import { SectionWrapper } from './SectionWrapper';
import { XCircle } from 'lucide-react';
export function PainPoints() {
  const pains = ['Probás técnicas que funcionan con otros niños pero con el tuyo generan más caos', 'Los berrinches, las peleas y los llantos se repiten y no sabés cómo cortarlos sin gritar', "Sentís que tu hijo es 'difícil' o 'intenso' y no encontrás por qué", 'Te vas a dormir con culpa casi todas las noches por cómo reaccionaste', 'No sabés cómo poner límites sin romper el vínculo con él', 'Cada etapa nueva te agarra sin herramientas y sin respuestas claras'];
  return <SectionWrapper data-id="element-210">
      <div className="max-w-4xl mx-auto" data-id="element-211">
        <h2 className="text-3xl md:text-5xl font-serif text-center text-burgundy mb-12" data-id="element-212">
          Si sos mamá, esto te va a sonar familiar:
        </h2>

        <div className="space-y-4 mb-12" data-id="element-213">
          {pains.map((pain, i) => <div key={i} className="bg-white p-6 rounded-xl shadow-sm border border-red-100 flex items-start gap-4 hover:shadow-md transition-shadow" data-id="element-214">
              <XCircle className="text-red-500 shrink-0 mt-1" size={24} data-id="element-215" />
              <p className="text-lg text-text-main/90 font-medium" data-id="element-216">{pain}</p>
            </div>)}
        </div>

        <div className="text-center bg-burgundy/5 p-8 rounded-2xl border border-burgundy/10" data-id="element-217">
          <p className="text-2xl md:text-3xl font-serif font-bold text-burgundy" data-id="element-218">
            ¿Cuántas noches más vas a irte a dormir sin entender a tu hijo?
          </p>
        </div>
      </div>
    </SectionWrapper>;
}